// extracted by mini-css-extract-plugin
module.exports = {"TitleSectionContainer":"TitleSection-module__TitleSectionContainer"};